export const formatCurrency = (amount: number | null | undefined): string => {
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  });
  
  return formatter.format(amount ?? 0);
};

